import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-allergens-modal',
  templateUrl: './allergens-modal.component.html',
  styleUrls: ['./allergens-modal.component.scss'],
  standalone: false,
})
export class AllergensModalComponent {
  constructor(private modalCtrl: ModalController) {}

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
